import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

// Check mode from environment variable
// Also check window location port as fallback
const getAppMode = () => {
  const envMode = process.env.REACT_APP_MODE;
  if (envMode) return envMode;
  
  // Fallback: check port number
  const port = window.location.port;
  if (port === '3001') return 'admin';
  if (port === '3000') return 'public';
  
  return 'all';
};

const appMode = getAppMode();

// Lazy load apps based on mode
const AppRoutes = React.lazy(() => import('./AppRoutes'));
const AdminApp = React.lazy(() => import('./admin/AdminApp'));

// Loading component
const Loading = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#64748b'
  }}>
    กำลังโหลด...
  </div>
);

// Main App based on mode
const MainApp = () => {
  // Admin-only mode (port 3001)
  if (appMode === 'admin') {
    return (
      <React.Suspense fallback={<Loading />}>
        <AdminApp />
      </React.Suspense>
    );
  }
  
  // Public-only mode (port 3000)
  if (appMode === 'public') {
    return (
      <React.Suspense fallback={<Loading />}>
        <AppRoutes />
      </React.Suspense>
    );
  }
  
  // All mode (both public + admin routes) - default
  return (
    <React.Suspense fallback={<Loading />}>
      <AppRoutes />
    </React.Suspense>
  );
};

const basename = process.env.REACT_APP_BASENAME || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={basename}>
        <MainApp />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

